module.exports = __webpack_public_path__ + "static/media/Azam Khan.227bc117.png";